import {Directive, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {ThemeService} from "../../../core/services/theme/theme.service";

@Directive({
  selector: '[appTheme]',
  exportAs: 'appTheme',
  standalone: true,
  // Permette di accedere a isDarkMode nel template
})
export class ThemeDirective implements OnInit, OnDestroy {
  private subscription!: Subscription;
  isDarkMode = false; // Variabile accessibile nel template
  isLightMode = true;

  constructor(private themeService: ThemeService) {}

  ngOnInit() {
    this.subscription = this.themeService.isLightMode().subscribe((isLightMode) => {
      this.isDarkMode = !isLightMode;
      this.isLightMode = isLightMode;
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
